/* eslint @typescript-eslint/ban-ts-comment: off */
import { DropzoneProps } from '@mantine/dropzone';
// @ts-ignore
import standardTypes from 'mime/types/standard.js';

import { portalFilenamify } from './portalFilenamify';

export const MIME_EXT_MAPPING_CSV = {
  'text/csv': ['csv'],
};

export const MIME_EXT_MAPPING_ZIP = {
  'application/x-zip-compressed': ['zip-compressed'],
};

export const MIME_EXT_MAPPING_EXCEL = {
  'application/vnd.ms-excel': ['xls', 'xlt', 'xla'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['xlsx'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.template': [
    'xltx',
  ],
  'application/vnd.ms-excel.sheet.macroEnabled.12': ['xlsm'],
  'application/vnd.ms-excel.template.macroEnabled.12': ['xltm'],
  'application/vnd.ms-excel.addin.macroEnabled.12': ['xlam'],
  'application/vnd.ms-excel.sheet.binary.macroEnabled.12': ['xlsb'],
};

export const MIME_EXT_MAPPING_PDF = {
  'application/pdf': ['pdf'],
};

export const MIME_EXT_MAPPING_WORD = {
  'application/msword': ['doc', 'dot'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [
    'docx',
  ],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.template': [
    'dotx',
  ],
  'application/vnd.ms-word.document.macroEnabled.12': ['docm'],
  'application/vnd.ms-word.template.macroEnabled.12': ['dotm'],
};

const mimetypes = Object.entries({
  ...(standardTypes as Record<string, string[]>),
  // Custom extension to the mime list
  ...MIME_EXT_MAPPING_CSV,
  ...MIME_EXT_MAPPING_EXCEL,
  ...MIME_EXT_MAPPING_PDF,
  ...MIME_EXT_MAPPING_WORD,
  ...MIME_EXT_MAPPING_ZIP,
}).reduce<Record<string, string[]>>((carry, [type, ext]) => {
  const baseType = type.slice(0, Math.max(0, type.indexOf('/')));
  const allType = `${baseType}/*`;

  return {
    ...carry,
    [type]: ext,
    [allType]: [...(carry[allType] ?? []), ...ext],
  };
}, {});

export default function getFileExtensions(accept: DropzoneProps['accept']) {
  if (Array.isArray(accept)) {
    return accept.flatMap((mimetype) => [...(mimetypes[mimetype] ?? [])]);
  } else if (accept != null) {
    return Object.entries(accept).flatMap(([mimetype, exts]) =>
      exts.length > 0 ? exts : [...(mimetypes[mimetype] ?? [])]
    );
  }

  return [];
}

export function getFileNameAndExtensionFromName(fileName: string) {
  if (typeof fileName !== 'string' || !fileName) {
    return {
      originalFileName: '',
      originalFileExtention: '',
    };
  }

  const lastDotIndex = fileName.lastIndexOf('.');

  // no extention or hidden file is uploaded
  if (lastDotIndex === -1 || fileName.startsWith('.')) {
    return {
      originalFileName: portalFilenamify(fileName),
      originalFileExtention: '',
    };
  }

  return {
    originalFileName: portalFilenamify(fileName.slice(0, lastDotIndex)),
    originalFileExtention: portalFilenamify(fileName.slice(lastDotIndex)),
  };
}
